export default __webpack_public_path__ + "static/media/fondo_imagen.030b8f39.jpg";